import { defineStore } from 'pinia';
import axios from 'axios';
import { formatDateAsDayMonthTime } from '@/mixins/globalHelpers.js';

export const useAppStore = defineStore('app', {

  state: () => ({
    maintenanceData: null,
  }),
  getters: {
    formattedStart () {
      return formatDateAsDayMonthTime(this.maintenanceData.start);
    },
    formattedEnd () {
      return formatDateAsDayMonthTime(this.maintenanceData.end);
    },
    showDuringMaintenance() {
      if (this.maintenanceData) {
        const currentDate = new Date();
        const maintenanceStartDate = new Date(this.maintenanceData.start);
        const maintenanceEndDate = new Date(this.maintenanceData.end);
        return currentDate >= maintenanceStartDate && currentDate <= maintenanceEndDate;
      }
      return false;
    },
    showPreMaintenance() {
      if (this.maintenanceData) {
        const maintenanceStartDate = new Date(this.maintenanceData.start);
        const twentyFourHoursFromNow = new Date();
        twentyFourHoursFromNow.setDate(twentyFourHoursFromNow.getDate() + 1);
        return maintenanceStartDate <= twentyFourHoursFromNow;
      }
      return false;
    },
  },
  actions: {
    async fetchMaintenanceData() {
      try {
        const response = await axios.get('https://bw-maintenance.azurewebsites.net/api/GetNextMaintenancePeriod');
        this.maintenanceData = response.data;
      } catch (error) {
        console.error('Error fetching maintenance period:', error);
        this.appStore.maintenanceData = null;
      }
    },
  }
})
